import { Vue, Component, } from 'vue-property-decorator'
import { State, namespace } from 'vuex-class'
import useragent from '@finance/useragent'

import { SHARE_URL } from '$utils/act-share'

const actModule = namespace('freeOrder')
@Component
export default class IndexMixin extends Vue {
  @State(state => state.common.loginState) isLogin!: boolean
  @actModule.Getter isTargetCustomer!: boolean

  // 按钮的统一回调处理
  async btnCommonHandle() {
    // 非随手记任务直接唤起
    if (!useragent.isSuishouji) {
      window.location.href = SHARE_URL
      return Promise.resolve(false)
    }

    // 未登录，登录动作
    if (!this.isLogin) {
      const flag = await this.$store.dispatch('normalLogin').then(() => {
        this.$store.dispatch('freeOrder/bootstrap', { force: true })
        return Promise.resolve(false)
      }).catch((err) => {
        console.log('normalLogin err', err)
        return Promise.resolve(false)
      })
      return Promise.resolve(flag)
    }

    // 判断是否目标客群
    if (!this.isTargetCustomer) {
      this.$ssvue.toast.show('抱歉，您当前无法参与该活动，请浏览其他活动')
      return Promise.resolve(false)
    }

    return Promise.resolve(true)
  }
}
